<template>
    <div>
        <table aria-describedby="Additional-scores-list">
            <thead>
                <tr>
                    <th>Score Name</th>
                    <th>Total</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item, index) in variableScoreList" :key="`additional-score-${item.body.id}-${index}`">
                    <td :title="item.body.name" class="ellipsis"><span>{{ item.body.name }}</span></td>
                    <td :title="item.body.score" class="ellipsis"><span>{{ item.body.score }}</span></td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
  
<script>
import nprogress from "nprogress";
import "nprogress/nprogress.css";
export default {
    props: {
        variablesList: {
            type: Array,
        },
        activityId: {
            type: String,
        },
        participantId: {
            type: String,
        },
        studyId: {
            type: String,
        },
        surveyId: {
            type: String,
        },
        responseVersionId: {
          type: String,
        },
        responseId: {
          type: String,
        },
        activityRevisionId: {
          type: String
        },
        reportedDataTrackerId: {
            type: String
        }
    },
    data() {
        return {
            variableScoreList: []
        }
    },
    methods: {
        async getVariableScoreList(responseVersionId, responseId) {
            this.variableScoreList = [];
            let responseVerId = responseVersionId ? responseVersionId : this.responseVersionId;
            let resId = responseId ? responseId : this.responseId;
            nprogress.start();
            if (this.variablesList && this.variablesList.length > 0) {
                for (const item of this.variablesList) {
                    let pathParams = {
                        studyId: this.studyId,
                        participantId: this.participantId,
                        activityId: item.activityId,
                        variableId: item.id,
                        responseId: resId,
                        responseVersionId: responseVerId,
                        activityRevisionId: item.activityRevisionId,
                        surveyId: this.surveyId
                    };
                    let queryParams = {
                        surveyResponseTrackerId: this.reportedDataTrackerId
                    };

                    try {
                        let response = await this.$api.evaluateVariable(pathParams, queryParams);
                        response.body.id = item.id;
                        this.variableScoreList.push(response);
                        nprogress.done();
                    }
                    catch (error) {                   
                        nprogress.done();
                        this.variableScoreList.push({ body: { id: item.id, name: item.name, score: (error.body && error.body.message) ? error.body.message: "Unable to evaluate" } });
                    }
                };
            }
        }
    },
    mounted() {
      this.getVariableScoreList();
      this.$root.$on('updateScoreValueTab', (responseVersionId, responseId) => {
        this.getVariableScoreList(responseVersionId, responseId);
      });
    },
    
}
</script>

<style scoped lang="scss">
table {
    width: 100%;

    thead {
        tr {
            background: #f9f9fb;
            padding-left: 30px;
            width: 100%;
            display: flex;

            th {
                width: 300px;
                font-size: 14px;
                font-family: Roboto-Bold;
                color: #4a4a4a;
                padding: 15px 30px 15px 0px;

                &:first-child {
                    border-right: 4px solid #fff;
                    width: 300px;
                }

                &:last-child {
                    width: 100%;
                    padding-left: 16px;
                }
            }
        }
    }

    tbody {
        tr {
            display: flex;
            width: 95%;
            border-bottom: 1px solid #d3dfe4;
            margin-left: 30px;

            td {
                font-size: 12px;
                font-family: Roboto-Bold;
                color: #4a4a4a;
                padding: 15px 0px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                width: 100%;
                &.ellipsis {
                    position: relative;
                }
                &.ellipsis:before {
                    content: '&nbsp;';
                    visibility: hidden;
                }
                &.ellipsis span {
                    position: absolute;
                    left: 0;
                    right: 0;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                &:first-child {
                    width: 300px;
                }

                &:last-child {
                    font-family: Roboto-Regular;
                    font-size: 14px;
                    span{
                        padding-left: 20px;
                    }
                }
            }
        }
    }
}
</style>
  